<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="is-pulled-left">
          <h1 class="title">Practice Locations and Providers</h1>
        </div>
      </div>
    </div>

    <div class="interview-edit">
      <div class="field" v-for="(location, index) in locations">
        <label class="label">Location {{ index + 1 }}</label>
        <div class="columns ml-2">
          <div class="column">
            <div class="control has-icons-right mt-2">
              <input
                type="text"
                :class="['input', { 'is-danger': errors[`location${index}`] }]"
                v-model="location.location"
                name="location"
              />
              <span
                class="icon is-small is-right"
                v-if="errors[`location${index}`]"
                ><i class="fa fa-warning"></i
              ></span>
            </div>
            <p v-if="errors[`location${index}`]" class="help is-danger">
              {{ errors[`location${index}`] }}
            </p>
          </div>
          <div class="column is-1 field-options">
            <i
              class="fa fa-plus-square-o mr1 pointer"
              @click="addLocation(index)"
            ></i>
            <i
              class="fa fa-minus-square-o pointer"
              v-if="index > 0"
              @click="removeLocation(index)"
            ></i>
            <i
              class="fa fa-minus-square-o has-text-grey-light"
              v-if="index < 1"
            ></i>
          </div>
        </div>

        <div class="providers">
          <div
            class="field"
            v-for="(provider, pIndex) in location['providers']"
          >
            <label class="label">Provider {{ pIndex + 1 }}</label>
            <div class="columns">
              <div class="column">
                <div class="control has-icons-right mt-2">
                  <input
                    :class="[
                      'input',
                      { 'is-danger': errors[`location${pIndex}`] }
                    ]"
                    v-model="provider['name']"
                    name="name"
                  />
                  <span
                    class="icon is-small is-right"
                    v-if="errors[`location${pIndex}`]"
                    ><i class="fa fa-warning"></i
                  ></span>
                </div>
                <p v-if="errors[`location${pIndex}`]" class="help is-danger">
                  {{ errors[`location${pIndex}`] }}
                </p>
              </div>
              <div class="column is-1 location-options">
                <i
                  class="fa fa-plus-square-o mr1 pointer"
                  @click="addProvider(index, pIndex)"
                ></i>
                <i
                  class="fa fa-minus-square-o pointer"
                  v-if="pIndex > 0"
                  @click="removeProvider(index, pIndex)"
                ></i>
                <i
                  class="fa fa-minus-square-o has-text-grey-light"
                  v-if="pIndex < 1"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        :class="['button', 'is-primary', { 'is-loading': working }]"
        @click="submit"
      >
        Save
      </button>
    </div>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import _ from "lodash";
import PracticesService from "@/services/PracticesService";

export default {
  name: "location-list",

  components: {
    alert
  },

  data() {
    return {
      errors: {},
      locations: [],
      working: false
    };
  },

  mounted() {
    this.locations = _.cloneDeep(this.$store.getters["practice/locations"]);
  },

  methods: {
    addLocation(index) {
      this.locations.splice(index + 1, 0, {
        location: "",
        providers: [{ name: "" }]
      });
    },

    removeLocation(index) {
      this.locations.splice(index, 1);
    },

    addProvider(index, pIndex) {
      this.locations[index].providers.splice(pIndex + 1, 0, { name: "" });
    },

    removeProvider(locationIndex, providerIndex) {
      this.locations[locationIndex].providers.splice(providerIndex, 1);
    },
    submit() {
      this.working = true;
      const current = this.$store.getters["practice/current"];
      PracticesService.update({
        id: current.id,
        locations: this.locations
      }).then(() => {
        this.working = false;
        this.$refs.toastr.s(
          "The locations have been updated. Please update any interview weights."
        );
        setTimeout(() => {
          this.$router.push({ name: "settings-index" });
        }, 2000);
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
